import { Card } from '@/components/ui/card';

const AdminSpam = () => (
  <Card className="p-6 text-center">
    <h1 className="text-xl font-semibold mb-2">Spam Management Disabled</h1>
    <p className="text-muted-foreground">Automated spam detection has been removed. Use manual moderation via Reports.</p>
  </Card>
);
export default AdminSpam;
